import axiosInstance from "./axiosInstance";

export const getAllQuizzes = async () => {
  const response = await axiosInstance.get("/quiz/all", {
    withCredentials: true,
  });
  return response.data;
};

export const getQuizById = async (id) => {
  const response = await axiosInstance.get(`/quiz/${id}`, {
    withCredentials: true,
  });
  return response.data;
};

export const startQuiz = async (quizId) => {
  const response = await axiosInstance.post(
    `/quiz/start/${quizId}`,
    {},
    { withCredentials: true }
  );
  return response.data;
};

export const submitQuizAttempt = async (quizId, answers) => {
  const response = await axiosInstance.post(
    `/quiz/submit/${quizId}`,
    {
      answers,
    }
  );

  return response.data;
};